import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  ECONOMY = 'Economy',
  GLOBAL = 'Global',
  TRADE = 'Trade',
  CENTRAL_BANKING = 'Central Banking',
  HOUSING = 'Housing',
  JOBS = 'Jobs',
  CONSUMERS = 'Consumers',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['economy'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['economy/global'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['economy/trade'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['economy/central-banking'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['economy/housing'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['economy/jobs'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['economy/consumers'] } }
    ]
  }
};

const GLOBAL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['economy/global'] } }]
  }
};

const TRADE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['economy/trade'] } }]
  }
};

const CENTRAL_BANKING = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['economy/central-banking'] } }]
  }
};

const HOUSING = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['economy/housing'] } }]
  }
};

const JOBS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['economy/jobs'] } }]
  }
};

const CONSUMERS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['economy/consumers'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'economy',
            'economy/global',
            'economy/trade',
            'economy/central-banking',
            'economy/housing',
            'economy/jobs',
            'economy/consumers'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'economy' } }, { prefix: { key: 'DJEThing', value: 'economy/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, GLOBAL, TRADE, CENTRAL_BANKING, HOUSING, JOBS, CONSUMERS, RELATED_OPINION, VIDEO };
